import { collection, doc, getDocs, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { parseContents } from '../utils';
import { Tab } from './types';
import { ProjectErrorType } from '../../utils/errors/types';
import { getProjectErrorFromRawError } from '../../utils/errors';

export const getAppConfiguration = async (): Promise<Tab[]> => {
  try {
    const result = await getDocs(collection(db, 'settings'));
    const parsedResult = parseContents(result);

    return parsedResult.filter((item) => item?.id === 'appConfiguration')?.[0]?.configuration as Tab[];
  } catch (error) {
    console.log('[APP CONFIGURATION] Error at getAppConfiguration:', error);
    return [];
  }
};

export const setAppConfiguration = async (configuration: Tab[]): Promise<void | ProjectErrorType> => {
  try {
    await setDoc(doc(db, 'settings', 'appConfiguration'), { configuration });
  } catch (error) {
    console.log('[APP CONFIGURATION] Error at setAppConfiguration:', error);
    return getProjectErrorFromRawError(error as Error);
  }
};
